export default __webpack_public_path__ + "static/media/COD分析仪.b3bb5490.png";